import { BookingType } from "../../Booking-Form/typings/booking-inputs";
import { BookingScheduleInterface } from "../../Booking-Form/typings/booking.types";
import { SelectFirstAidOptions } from "../partial/ScheduleFirstAidSelect.partial";

const isNonVehicleSchedule = (schedule: BookingScheduleInterface) =>
  schedule.bookingType !== BookingType.VEHICLE;

export function handleFirstAidFilterOptions({
  schedules,
  selectFirstAidOptions,
  allFirstAidSchedules,
  setSchedules,
  setAllFirstAidSchedules
}: {
  schedules: BookingScheduleInterface[];
  selectFirstAidOptions: SelectFirstAidOptions;
  allFirstAidSchedules: BookingScheduleInterface[];
  setSchedules: (value: BookingScheduleInterface[]) => void;
  setAllFirstAidSchedules: (value: BookingScheduleInterface[]) => void;
}) {
  const { options: selectedFirstAidOptions, reason: selectedReason } = selectFirstAidOptions;

  // initially, no selectFirstAidOptions are selected and show all first aid users' booking schedule
  if (!selectedFirstAidOptions.length) {
    // store all the first aid users' booking schedule for the first time
    if (selectedReason === null)
      return setAllFirstAidSchedules(schedules.filter(isNonVehicleSchedule));

    // when filter is out, turn back to all the first aid booking schedules
    if (selectedReason === "removeOption" || selectedReason === "clear") {
      return setSchedules(allFirstAidSchedules.filter(isNonVehicleSchedule));
    }
  }

  // when firstAidOptions are selected(filtering), filter the booking schedules
  const filteredSchedules = allFirstAidSchedules.filter(schedule =>
    selectedFirstAidOptions.some(
      option =>
        option.locationName === schedule.locationName && option.floorName === schedule.floorName
    )
  );

  // filter vehicle schedules out
  const filteredVehicleSchedules = filteredSchedules.filter(isNonVehicleSchedule);

  setSchedules(filteredVehicleSchedules);
}
